import React from "react";
import { Typography, Tooltip, ConfigProvider } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Title } = Typography;

interface TitleWithTooltipProps {
  title: React.ReactNode;
  tooltipText: React.ReactNode;
  titleLevel?: 1 | 2 | 3 | 4 | 5;
  titleStyle?: React.CSSProperties;
  titleColor?: string;
  tooltipColor?: string;
  className?: string;
  showTooltip?: boolean;
}

const TitleTooltip: React.FC<TitleWithTooltipProps> = ({
  title,
  tooltipText,
  titleLevel = 4,
  titleStyle = {},
  titleColor,
  tooltipColor = "#1890ff",
  className = "",
  showTooltip = true,
}) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Tooltip: {
            colorBgSpotlight: tooltipColor,
          },
        },
      }}
    >
      <div className={`inline-flex items-center my-2.5 ${className}`}>
        <Title
          level={titleLevel}
          style={{
            ...titleStyle,
            margin: "10px 1px",
            display: "inline-flex",
            alignItems: "center",
            color: titleColor,
          }}
        >
          <span>{title}</span>
          {showTooltip && (
            <Tooltip title={tooltipText} color={tooltipColor}>
              <InfoCircleOutlined
                style={{
                  color: tooltipColor,
                  cursor: "help",
                  fontSize: "0.75em",
                  verticalAlign: "middle",
                  marginLeft: "8px",
                }}
              />
            </Tooltip>
          )}
        </Title>
      </div>
    </ConfigProvider>
  );
};

export default TitleTooltip;
